<!-- @format -->

<top-tag>
  <div class="contents">
    <section class="contents_area">
      <div class="container_heading">
        <h1 class="heading-01 heading_news">お知らせ</h1>
        <div class="button_link"><a href="/menu/information">全て見る</a></div>
      </div>
      <!--/.container_heading-->
      <div class="contents_block">
        <ul class="table_list">
          <li class="table_list-item" each="{info in state.informations}">
            <span class="date">{info.created_at}</span>
            <span class="label {informationLabel(info.service)}"></span>
            <a href="/menu/information/detail/{info.id}">{info.title}</a>
          </li>
        </ul>
        <p if="{state.informations.length == 0}">お知らせはありません。</p>
      </div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
    <section class="contents_area">
      <div class="container_heading">
        <h1 class="heading-01 heading_orders">注文一覧</h1>
        <div class="button_link"><a href="/menu/order">全て見る</a></div>
      </div>
      <!--/.container_heading-->
      <div class="contents_block table_top">
        <table class="contents_table">
          <tbody>
            <tr class="column_orders">
              <th class="date">お申込日</th>
              <th class="service">サービス名</th>
              <th class="order-id">注文ID / 注文名</th>
              <th class="price">金額（税込）</th>
              <th class="person">担当者</th>
              <th class="status">ステータス</th>
            </tr>
            <tr each="{ (order,i) in state.orders }">
              <td><span class="date">{order.ordered_date}</span></td>
              <td>{order.source}</td>
              <td>
                <a class="order-id" onclick="{(e)=>orderDetail(e,order)}">
                  {order.id} / {order.name}
                </a>
              </td>
              <td>{Number(order.price).toLocaleString()}円</td>
              <td if="{order.source != 'EDILENT'}">{order.staff}</td>
              <td if="{order.source == 'EDILENT'}">
                { username(order.staff) }
              </td>
              <td>
                <span class="{OrderStatus(order.status).class}">
                  {OrderStatus(order.status).text}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <!--/.contents_table-->
      </div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
    <section class="contents_area">
      <h1 class="heading-01 heading_tool">CROCOのWEBマーケティングツール</h1>
      <div class="banner_area">
        <div class="banner">
          <a
            href="https://yori-co{state.serviceBaseDomain}/hub-auth"
            target="_blank"
          >
            <div class="banner_box">
              <div class="banner_illust yorico"></div>
              <div class="banner_text">
                <div class="sarvice_name">
                  <img src="/assets/img/logo_yorico.svg" alt="yori-co" />
                </div>
                <p class="service_lead">
                  ECサイトの商品紹介文を訪問者のペルソナに合わせて差し替える
                </p>
              </div>
            </div>
            <!--banner_box-->
          </a>
        </div>
      </div>
      <div class="banner_area" style="margin-top: 20px">
        <div class="banner mini">
          <a href="https://tami-co{state.serviceBaseDomain}/" target="_blank">
            <div class="banner_box">
              <div class="banner_icon tamico"></div>
              <div class="banner_text_tool">
                <div class="sarvice_name-tool">tami-co</div>
                <p class="service_lead-left">
                  検索エンジンに好かれる記事の企画・指示書の作成に役立つツール！
                </p>
              </div>
            </div>
            <!--banner_box-->
          </a>
        </div>
        <div class="banner mini">
          <a href="https://ruri-co{state.serviceBaseDomain}/" target="_blank">
            <div class="banner_box">
              <div class="banner_icon rurico"></div>
              <div class="banner_text_tool">
                <div class="sarvice_name-tool">ruri-co</div>
                <p class="service_lead-left">
                  検索結果の類似率を調査できるWEBマーケティングツール！
                </p>
              </div>
            </div>
            <!--banner_box-->
          </a>
        </div>
      </div>
      <!--/.banner_area-->
    </section>
    <!--/.contents_area-->
    <section class="contents_area">
      <h1 class="heading-01 heading_write">編集・ライティングの仕事を依頼</h1>

      <div class="banner_area">
        <div class="banner">
          <a
            href="https://edilent-client{state.serviceBaseDomain}/"
            target="_blank"
          >
            <div class="banner_box">
              <div class="banner_illust edilent"></div>
              <div class="banner_text">
                <div class="sarvice_name">
                  <img src="/assets/img/logo_edilent.svg" alt="EDILENT" />
                </div>
                <p class="service_lead">
                  ライターを公募、または指定して記事制作
                </p>
              </div>
            </div>
          </a>
        </div>
        <div class="banner">
          <a href="https://lp-form{state.serviceBaseDomain}/" target="_blank">
            <div class="banner_box">
              <div class="banner_illust crocodesk"></div>
              <div class="banner_text">
                <div class="sarvice_name">
                  <img src="/assets/img/logo_crocodesk.svg" alt="CROCOデスク" />
                </div>
                <p class="service_lead">PMなどフルコンサルティングで記事制作</p>
              </div>
            </div>
            <!--banner_box-->
          </a>
        </div>
      </div>
      <!--/.banner_area-->
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->
  <agreement-modal
    modalId="agreement-modal"
    MenuApi="{MenuApi}"
    agree="{agree}"
  ></agreement-modal>

  <register-navi-modal
    is-open="{ state.naviModalIsOpen }"
    on-close="{ e => update({naviModalIsOpen: false}) }"
  ></register-navi-modal>

  <register-complete-modal
    is-open="{ state.completeModalIsOpen }"
    on-close="{ e => update({completeModalIsOpen: false}) }"
  ></register-complete-modal>

  <script>
    import di from "dependeny-injection";
    import qs from "qs";
    import InformationLabel from "@model/information-label.js";
    import agreementModal from "@tags/modal/menu/agreement-modal.riot";
    import registerNaviModal from "@tags/modal/menu/register-navi-modal.riot";
    import registercompleteModal from "@tags/modal/menu/register-complete-modal.riot";

    import Status from "@model/status.js";
    export default {
      components: {
        "agreement-modal": agreementModal,
        "register-navi-modal": registerNaviModal,
        "register-complete-modal": registercompleteModal,
      },
      OrderStatus: Status.order,
      informationLabel: InformationLabel.get,
      state: {
        serviceBaseDomain: window.__INITIAL_PROPS__.serviceBaseDomain,
        naviModalIsOpen: false,
        completeModalIsOpen: false,
        informations: [],
        orders: [],
      },
      username(bizid) {
        return window.__INITIAL_PROPS__.users[bizid] || "-";
      },
      agree() {
        this.MenuApi.request("index", "send-agreement")
          .then((data) => this.MenuApi.event("agreement", "closeModal"))
          .catch((err) => alert(err));
      },
      orderDetail(e, order) {
        window.open(order.detail_link, `order-${order.id}`);
      },
      onBeforeMount(props, state) {
        this.MenuApi = di.createApi();
        this.MenuApi.request("information", "fetch", {
          limit: 3,
        }).then((data) => this.update({ informations: data.items }));
        this.MenuApi.request("order", "fetch", { limit: 5 }).then((data) =>
          this.update({ orders: data.items })
        );

        //HUBの利用規約はCROCO IDに集約するということになったので、利用規約表示をなくす
        //this.MenuApi.request('index', 'fetch-agreement')
        //  .then(data => {
        //    if (!data) this.MenuApi.event('agreement','openModal')
        //  })
      },
      onMounted(props, state) {
        const q = qs.parse(location.search.slice(1));
        switch (q.modal) {
          case "register-navi":
            this.update({ naviModalIsOpen: true });
            break;
          case "register-complete":
            this.update({ completeModalIsOpen: true });
            break;
        }
        switch (q.login) {
          case "2":
            window.analytics.event("sign_up", {
              event_category: "engagement",
              event_label: "新規登録",
            });
            break;
        }
        window.history.replaceState({}, document.title, location.pathname);
      },
    };
  </script>
  <style>
    .yorico {
      background-image: url(/assets/img/ill_banner-yorico.png);
    }
  </style>
</top-tag>
